import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { JobEffects } from './job.effects';
import { jobReducer } from './job.reducer';

/**
 * Standalone providers for the `jobs` NgRx feature slice (SEOMS-437).
 * Replaces the former `JobStoreModule`.
 */
export function provideJobsStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState('jobs', jobReducer),
    provideEffects([JobEffects]),
  ]);
}
